export default __webpack_public_path__ + "static/media/tree.4347adbb.png";